import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import qs from 'qs';

import Layout from 'components/common/Layout';
import LoginConfirm from 'components/account/LoginConfirm';
import AccountNavigation from 'components/account/AccountNavigation';
import AccountLogo from 'components/account/AccountLogo';

import { appTitle, titleSeparator } from 'config/helmetSettings';
import tidioSrc from 'config/tidioSrc';

class AccountLogin extends Component {
  componentDidMount() {
    const { history } = this.props;
    const htmlEl = document.querySelector('html');
    htmlEl.classList.add('page-with-tidio');
    if (!history.location.state || !history.location.state.auth_id) {
      history.replace('/account/login');
    }
  }

  componentWillUnmount() {
    const htmlEl = document.querySelector('html');
    htmlEl.classList.remove('page-with-tidio');
  }

  render() {
    const { history } = this.props;
    const loginParams = qs.stringify({
      login: true,
    }, {
      encode: false, addQueryPrefix: true,
    });
    return (
      <Layout variant="account-login">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Log In
          </title>
          <script src={tidioSrc} async />
        </Helmet>
        <AccountLogo />
        <LoginConfirm
          initialValues={{
            ...history.location.state && history.location.state.auth_id ? {
              Email: history.location.state.auth_id.toString(),
            } : {},
          }}
          onSubmitSuccess={(values) => {
            const redirectOrigin = new URL(values.url).origin;
            window.location.replace(`${redirectOrigin}${loginParams}`);
          }}
        />
        <AccountNavigation />
      </Layout>
    );
  }
}

AccountLogin.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
};

export default AccountLogin;



// WEBPACK FOOTER //
// ./src/pages/account/AccountLoginConfirm.js